import React from 'react';

import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <ConfluenceIcon size="xsmall" label="" />;

export const useConfluence = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.CONFLUENCE,
		analyticsName: Products.CONFLUENCE,
		...options,
	});
